import {LocalDate} from '@js-joda/core';
import {subDisplayDate} from '@/functions/buildSubDisplayDateConfig';
import getConfigForDate from '@/functions/getConfigForDate';
import type {CapacityConfig, CapacityConfigItemEnhanced} from '@/types/CapacityConfig';

const buildConfigPerFiscalMonth = (
    capacityConfig : CapacityConfig,
    yearMonthsDisplay : string[]
) : Record<string, CapacityConfigItemEnhanced> => {
    const configsPerFiscalMonth : Record<string, CapacityConfigItemEnhanced> = {};

    for (const capacityYearMonth of yearMonthsDisplay) {
        const capacityYearMonthSplit = capacityYearMonth.split('-');
        const theDate = LocalDate.of(
            parseInt(capacityYearMonthSplit[0]),
            parseInt(capacityYearMonthSplit[1]),
            15
        );

        const foundConfig = getConfigForDate(capacityConfig, theDate);

        if (foundConfig) {
            configsPerFiscalMonth[capacityYearMonth] = {
                ...foundConfig,
                subDisplay: subDisplayDate(new Date(foundConfig.fiscalstart))
                    + ' - ' + subDisplayDate(new Date(foundConfig.fiscalend)),
            };
        } else {
            configsPerFiscalMonth[capacityYearMonth] = {
                calendar: 0,
                fiscal: 0,
                fiscalend: '',
                fiscalstart: '',
                subDisplay: 'unknown',
                hours: 0,
            };
        }
    }

    return configsPerFiscalMonth;
};

export default buildConfigPerFiscalMonth;
